import {
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import LoggedOutLayout from 'components/layout/LoggedOutLayout';
import Link from 'components/ui/Link';
import useQuery from 'hooks/useQuery';
import { openSnackbarSuccess } from 'store/snackbarSlice';
import showSnackbarError from 'utils/showSnackbarError';

import LoginForm from './LoginForm';

const LoginPage = () => {
  const query = useQuery();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const from = location.state?.from?.pathname || '/';
  console.log(from);
  const verificationStatus = query.get('verificationStatus');

  useEffect(() => {
    if (verificationStatus === 'success') {
      dispatch(openSnackbarSuccess('Your registration has been confirmed!'));
    }

    if (verificationStatus === 'error') {
      dispatch(
        showSnackbarError('Invalid link provided, please request a link again.')
      );
    }
  }, [verificationStatus]);

  return (
    <LoggedOutLayout>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Stack alignItems="center" justifyContent="center" spacing={1}>
            <Typography
              color={theme.palette.secondary.main}
              gutterBottom
              variant={matchDownSM ? 'h3' : 'h2'}
            >
              Hi, Welcome Back
            </Typography>
            <Typography
              variant="caption"
              fontSize="16px"
              textAlign={matchDownSM ? 'center' : ''}
            >
              Enter your credentials to continue
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <LoginForm />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Grid item display="flex" justifyContent="center" xs={12}>
            <Typography
              component={Link}
              href="/register"
              variant="subtitle1"
              sx={{ textDecoration: 'none' }}
            >
              Don&apos;t have an account?
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </LoggedOutLayout>
  );
};

export default LoginPage;
